module.exports = "img/34.f82a90.webp";